import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/onaylarimlogo.png'


const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "px-4 py-4 bg-gray-200 flex flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-8 ml-5 mr-10",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "w-full flex-grow overflow-y-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(({ isActive }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["w-40 text-center mx-2 py-2 text-sm font-medium focus:outline-none cursor-pointer", [isActive ? 'text-gray-800 bg-white' : 'text-gray-400 bg-gray-100 hover:text-gray-900 focus:text-gray-900']])
          }, " Login", 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/receipts" }, {
        default: _withCtx(({ isActive }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["w-40 text-center mx-2 py-2 text-sm font-medium focus:outline-none cursor-pointer", [isActive ? 'text-gray-800 bg-white' : 'text-gray-400 bg-gray-100 hover:text-gray-900 focus:text-gray-900']])
          }, " Receipts", 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/moneyTransfers" }, {
        default: _withCtx(({ isActive }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["w-40 text-center mx-2 py-2 text-sm font-medium focus:outline-none cursor-pointer", [isActive ? 'text-gray-800 bg-white' : 'text-gray-400 bg-gray-100 hover:text-gray-900 focus:text-gray-900']])
          }, " Money Transfers", 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/payTrPayments" }, {
        default: _withCtx(({ isActive }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["w-40 text-center mx-2 py-2 text-sm font-medium focus:outline-none cursor-pointer", [isActive ? 'text-gray-800 bg-white' : 'text-gray-400 bg-gray-100 hover:text-gray-900 focus:text-gray-900']])
          }, " PayTR Payments", 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/organizationsList" }, {
        default: _withCtx(({ isActive }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["w-40 text-center mx-2 py-2 text-sm font-medium focus:outline-none cursor-pointer", [isActive ? 'text-gray-800 bg-white' : 'text-gray-400 bg-gray-100 hover:text-gray-900 focus:text-gray-900']])
          }, " Organizations", 2)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/reportsView" }, {
        default: _withCtx(({ isActive }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["w-40 text-center mx-2 py-2 text-sm font-medium focus:outline-none cursor-pointer", [isActive ? 'text-gray-800 bg-white' : 'text-gray-400 bg-gray-100 hover:text-gray-900 focus:text-gray-900']])
          }, " Reports", 2)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_view, { class: "w-full h-full" })
    ])
  ]))
}